export const CAB_TYPE_FORM_OPTIONS = [
  { value: 'Normal', label: 'Normal' },
  { value: 'Emergency', label: 'Emergency' },
] as const;

/** Group types allowed in the Board Groups lookup for CAB Definitions. */
export const CAB_BOARD_GROUP_TYPES = ['assignment', 'approval'] as const;

export const CAB_CONFERENCE_TYPE_OPTIONS = [
  { value: 'Microsoft Teams', label: 'Microsoft Teams' },
  { value: 'Other', label: 'Other' },
] as const;

export const CAB_DEFINITION_DEFAULTS = {
  cabType: 'Normal',
  active: true,
  conferenceType: 'Microsoft Teams',
} as const;
